var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 20",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 3738"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#64849f",
    d: "M0 1.2A1.2 1.2 0 0 1 1.2 0H10l5 4.2v14.6a1.2 1.2 0 0 1-1.2 1.2H1.2A1.2 1.2 0 0 1 0 18.8Z",
    "data-name": "Pfad 669"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#76b5e4",
    d: "M10 0v3a1.2 1.2 0 0 0 1.2 1.2H15",
    "data-name": "Pfad 670"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export default ForwardRef;